<template>
  <div>
    <form name="paymentForm" id="payment-form" class="form-area dynamic" :class="stripeErrCode" v-on:submit.prevent="submit" novalidate>
      <div class="form-row">
        <p ref="name-error" class="field-error" :class="{ 'show-error' : errors.current === 'name' }">Grr... Don't forget to put in your name.</p>
        <div class="input-wrap" :class="{ 'show-error' : errors.current === 'name' }">
          <input v-model="payment.name" id="name" name="name" type="text" :class="{'active': (activeField.name || payment.name)}" @focus="activeField.name = true" required>
          <label for="name">Name on Card</label>
        </div>
      </div>
      <div class="form-row">
        <div class="input-wrap" :class="{ 'show-error' : errors.current === 'card' }">
          <p ref="card-error" class="field-error">{{ stripeCardError }}</p>
          <div id="card-element" class="input"></div>
          <div id="card-errors" role="alert"></div>
        </div>
      </div>
      <div class="form-section">
        <p ref="street-error" class="field-error error-left" :class="{ 'show-error' : errors.current === 'street' }">Can you double check that address?</p>
        <p ref="city-error" class="field-error error-right" :class="{ 'show-error' : errors.current === 'city' }">Can you double check that city?</p>
        <div class="input-wrap input-left" :class="{ 'show-error' : errors.current === 'street'}">
          <input v-model="payment.street" id="street" name="street" type="text" :class="{'active': (activeField.street || payment.street)}" @focus="activeField.street = true" required>
          <label for="street">Street</label>
        </div>
        <div class="input-wrap input-right" :class="{ 'show-error' : errors.current === 'city' }">
          <input v-model="payment.city" id="city" name="city" type="text" :class="{'active': (activeField.city || payment.city)}" @focus="activeField.city = true" required>
          <label for="city">City</label>
        </div>
      </div>
      <div class="form-row">
        <div class="input-wrap" :class="{ 'show-error' : errors.current === 'country' }">
          <p ref="country-error" class="field-error">Please select your country.</p>
          <div class="select-wrap">
            <select v-model="payment.country" :country="location.country" id="country" name="country" @change="selectedCountry = true" :class="{'selected' : selectedCountry, 'active': (activeField.country || payment.country)}" @focus="activeField.country = true" required>
              <option value="" disabled selected style="display: none"></option>
              <option value="" disabled>Country</option>
              <option value="" disabled>-------------------</option>
              <option value="CA">Canada</option>
              <option value="GB">United Kingdom</option>
              <option value="US">United States</option>
              <option value="" disabled>-------------------</option>
              <option v-for="[iso2, country] in Object.entries(locations.countries)" :value="iso2" v-bind:key="iso2">{{country}}</option>
            </select>
            <label for="country">Country</label>
            <span id="country-caret" class="caret"></span>
          </div>
        </div>
      </div>
      <div v-show="payment.country === 'US' || payment.country === 'CA'" class="form-section">
        <p ref="stateProv-error" class="field-error error-left" :class="{ 'show-error' : errors.current === 'stateProv' }">Please select your {{payment.country === 'US' ? 'state' : 'province'}}.</p>
        <div class="input-wrap input-left" :class="{ 'show-error' : errors.current === 'stateProv'}">
          <div class="select-wrap">
            <select v-model="payment.state" id="state" name="state" v-show="payment.country === 'US'" @change="selectedState = true" :class="{'selected' : selectedState, 'active': (activeField.state || payment.state) }" @focus="activeField.state = true" :required="payment.country === 'US'">
              <option value="" disabled selected style="display: none"></option>
              <option value="" disabled>State</option>
              <option v-for="[iso2, state] in Object.entries(locations.states)" :value="iso2"  v-bind:key="iso2">{{state}}</option>
            </select>
            <label v-show="payment.country === 'US'" for="state">State</label>
            <select v-model="payment.province" id="province" name="province" v-show="payment.country === 'CA'" @change="selectedProvince = true" :class="{'selected' : selectedProvince, 'active': (activeField.province || payment.province)}" @focus="activeField.province = true" :required="payment.country === 'CA'">
              <option value="" disabled selected style="display: none"></option>
              <option value="" disabled>Province</option>
              <option v-for="[iso2, province] in Object.entries(locations.provinces)" :value="iso2"  v-bind:key="iso2">{{province}}</option>
            </select>
            <label v-show="payment.country === 'CA'" for="province">Province</label>
            <span id="country-caret" class="caret"></span>
          </div>
        </div>
      </div>
      <p class="fine-print text-left encrypt">Your payment data is encrypted and secure. <br></p>
    </form>
  </div>
</template>

<script>
// import services from '../../services/services.js'
import validator from '../../mixins/validator.js'
import Stripe from 'stripe'
import is from 'is_js'

export default {
  name: 'payment-form',
  props: ['transaction', 'config'],
  mixins: [validator],
  data () {
    return {
      is: is,
      thisYear: (new Date()).getFullYear(),
      cardType: '',
      selectedCountry: false,
      selectedProvince: false,
      selectedState: false,
      stripeErrCode: '',
      stripeCardError: 'Hmm... make sure you fill in all your credit card details.',
      activeField: {
        name: false,
        street: false,
        city: false,
        country: false,
        state: false,
        province: false
      },
      payment: {
        name: '',
        street: '',
        city: '',
        country: '',
        state: '',
        province: ''
      },
      submitted: false,
      cvcInfo: false,
      card: null,
      stripe: null
    }
  },
  mounted: function () {
    this.stripe = Stripe(this.ENV.stripeKey)
    let elements = this.stripe.elements({
      fonts: [
        {
          family: 'Montserrat',
          cssSrc: 'https://fonts.googleapis.com/css?family=Montserrat&display=swap',
          style: 'normal',
          weight: '400'
        }
      ]
    })
    this.card = elements.create('card', {style: {
      base: {
        fontFamily: 'Montserrat, Trebuchet, sans-serif',
        fontWeight: '400',
        fontSmoothing: 'antialiased',
        fontStyle: 'normal',
        fontSize: window.innerWidth <= 575 ? '16px' : '18px',
        color: '#6e6e6e',
        '::placeholder': {
          color: '#6e6e6e'
        }
      },
      invalid: {
        color: '#F76565'
      }
    }})
    this.card.addEventListener('change', this.cardChange)
    this.card.mount('#card-element')
  },
  computed: {
    validations: function () {
      let validations = {
        'name': [this.payment.name, this.payment.name.length > 1],
        'card': [this.stripeCardError === ''],
        'street': [this.payment.street],
        'city': [this.payment.city],
        'country': [this.payment.country]
      }
      if (this.payment.country === 'CA') {
        validations = Object.assign(validations, {
          'stateProv': [this.payment.province]
        })
      }
      if (this.payment.country === 'US') {
        validations = Object.assign(validations, {
          'stateProv': [this.payment.state]
        })
      }
      return validations
    },
    showDiscount: function () {
      return parseInt(this.pricing.YEARLY_PAYMENT_RECURRING.chargePrice) < parseInt(this.pricing.YEARLY_PAYMENT_RECURRING.regularPrice)
    },
    location: function () {
      let location = {
        country: this.payment.country,
        state: this.payment.state || this.payment.province || ''
      }
      this.$root.$emit('countryChange', location)
      return location
    }
  },
  methods: {
    cardChange: function (event) {
      if (event.error) {
        this.stripeCardError = event.error.message
      } else if (!event.complete) {
        this.stripeCardError = 'Hmm... make sure you fill in all your credit card details.'
      } else {
        this.stripeCardError = ''
      }
    },
    scrollToError: function (current) {
      let errorEl = this.$refs[current + '-error']
      if (errorEl) {
        let position = errorEl.getBoundingClientRect()
        if (position.y < 0) {
          window.scrollBy({
            top: (position.y - 20),
            behavior: 'smooth'
          })
        }
      }
    },
    getCardType: function (value) {
      if (/^5[1-5][0-9]{14}$/.test(value)) {
        this.cardType = 'mastercard'
      } else if (/^4[0-9]{12}(?:[0-9]{3})?$/.test(value)) {
        this.cardType = 'visa'
      } else if (/^3[47][0-9]{13}$/.test(value)) {
        this.cardType = 'amex'
      } else {
        this.cardType = ''
      }
    },
    makeRequest: function () {
      this.$store.dispatch('submitting', true)
      let card = {
        name: this.payment.name,
        address_line1: this.payment.street,
        address_city: this.payment.city,
        address_country: this.payment.country,
        address_state: this.location.state
      }
      this.stripe.createToken(this.card, card).then((result) => {
        if (result.error && result.error.code) {
          this.$emit('paymentResponse', result)
          if (result.error.code) this.stripeErrCode = result.error.code
        } else {
          this.$emit('paymentResponse', result)
        }
      })
    },
    clearState: function () {
      if (this.selectedState) {
        this.payment.state = ''
        this.activeField.state = false
        this.selectedState = false
      } else if (this.selectedProvince) {
        this.payment.province = ''
        this.activeField.province = false
        this.selectedProvince = false
      }
      this.activeField.zip = false
      this.payment.zip = ''
    },
    isValidated: function () {
      this.submitted = true
      this.$emit('validated', this.errors.all.length === 0)
      if (this.errors.all.length > 0) {
        setTimeout(() => {
          this.scrollToError(this.errors.current)
        }, 100)
      }
    },
    submit: function () {
      if (this.$store.getters.submitting) return
      this.submitted = true
      this.stripeErrCode = ''
      if (this.errors.all.length === 0) {
        this.makeRequest()
      } else {
        setTimeout(() => {
          this.scrollToError(this.errors.current)
        }, 100)
      }
    }
  },
  beforeDestroy: function () {
    this.card.removeEventListener('change', this.cardChange)
  },
  watch: {
    'payment.country': {
      handler: function () {
        this.clearState()
      }
    }
  }
}
</script>

<style scoped lang="stylus" src="./payment-form.styl" >



// WEBPACK FOOTER //
// src/components/payment-form/payment-form.vue